import {Box, Button, Grid, Paper, Stack, Typography} from '@mui/material';
import {NotListedLocation, People} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import '../../styles/components/quiz-grid.css';
import '../../styles/components/open-games.css';

// Quiz-Bilder importieren
import exampleQuiz from '../../img/quiz/example-quiz.jpg';
import deutschlandQuiz from '../../img/quiz/deutschland-quiz.jpg';
import fortniteQuiz from '../../img/quiz/fortnite-battle-royale-quiz.jpg';
import harryPotterQuiz from '../../img/quiz/harry-potter-quiz.jpg';
import internetMemeQuiz from '../../img/quiz/internet-meme-quiz.jpg';
import kurioseFaktenQuiz from '../../img/quiz/kuriose-fakten-quiz.jpg';
import marvelSuperheldenQuiz from '../../img/quiz/marvel-superhelden-quiz.jpg';
import pixarFilmquiz from '../../img/quiz/pixar-filmquiz.jpg';
import skibidiToiletQuiz from '../../img/quiz/skibidi-toilet-quiz.jpg';
import defaultQuiz from '../../img/quiz/default.jpg';

export default function OpenGames({ games = []}) {
  const navigate = useNavigate();

  const getQuizImage = (quizId) => {
    if (!quizId) return defaultQuiz;
    
    switch (quizId) {
      case 'example-quiz': return exampleQuiz;
      case 'deutschland-quiz': return deutschlandQuiz;
      case 'fortnite-battle-royale-quiz': return fortniteQuiz;
      case 'harry-potter-quiz': return harryPotterQuiz;
      case 'internet-meme-quiz': return internetMemeQuiz;
      case 'kuriose-fakten-quiz': return kurioseFaktenQuiz;
      case 'marvel-superhelden-quiz': return marvelSuperheldenQuiz;
      case 'pixar-filmquiz': return pixarFilmquiz;
      case 'skibidi-toilet-quiz': return skibidiToiletQuiz;
      default: return defaultQuiz;
    }
  };

  // Sicherstellen, dass games ein Array ist
  if (!Array.isArray(games) || games.length === 0) {
    return (
      <Paper 
        className="quiz-grid-item quiz-grid-item-empty"
      >
        <Typography className="open-games-text">
          Momentan gibt es keine offenen Spiele. Wähle ein Quiz aus der Liste unten aus, um eine neue Lobby zu erstellen.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box className="quiz-grid-container">
      <Grid container spacing={3}>
        {games.map((game) => {
          if (!game) return null;
          
          console.log('Game data:', {
            gameId: game.id,
            currentQuiz: game.currentQuiz,
            quizId: game.currentQuiz?.quizId
          });
          
          return (
            <Grid item xs={12} sm={6} md={4} key={game.id}>
              <Paper className="quiz-grid-item">
                <Box 
                  className="quiz-grid-image"
                  sx={{
                    backgroundImage: `url(${getQuizImage(game.currentQuiz?.quizId)})`
                  }}
                >
                  <Box className="quiz-grid-flag">
                    {game.id}
                  </Box>

                  <Box className="quiz-grid-image-content">
                    <Box className="open-games-title-wrapper">
                      <Typography className="quiz-grid-title">
                        Lobby von {Object.values(game.players || {}).find(p => p.isGameMaster)?.displayName || 'Unbekannt'}
                      </Typography>
                    </Box>

                    <Box className="quiz-grid-stats">
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Stack direction="row" spacing={0.5} alignItems="center">
                          <NotListedLocation className="quiz-grid-stats-icon" fontSize="small" />
                          <Typography variant="body2" className="quiz-grid-stats-text">
                            {game.currentQuiz?.title || 'Kein Quiz ausgewählt'}
                          </Typography>
                        </Stack>
                      </Stack>

                      <Box className="quiz-grid-stats-group">
                        <Stack direction="row" spacing={1} alignItems="center">
                          <People className="quiz-grid-stats-icon" fontSize="small" />
                          <Typography className="quiz-grid-stats-text">
                            {Object.keys(game.players || {}).length} {Object.keys(game.players || {}).length === 1 ? 'Spieler' : 'Spieler'}
                          </Typography>
                        </Stack>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box className="quiz-grid-content">
                  <Box className="quiz-grid-actions">
                    <Button
                      variant="contained"
                      className="quiz-grid-play-button"
                      onClick={() => game.id && navigate(`/lobby/${game.id}`)}
                      fullWidth
                    >
                      Beitreten
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
} 